import _ from 'lodash';

export function baseUnit(productDetails: any): string {
  const sellingUnit = _.get(productDetails, 'unit.unit2');
  const packingMode = _.get(productDetails, 'packingMode', []);
  if(!sellingUnit || !packingMode.length) return '';
  if(sellingUnit === packingMode[0].unit1) {
    return sellingUnit;
  }
  if(sellingUnit == packingMode[0].unit2) {
    return `${packingMode[0].quantity} ${packingMode[0].unit1}`;
  }
  if(packingMode.length < 2) return '';
  if(sellingUnit == packingMode[1].unit2) {
    return `${packingMode[1].quantity} ${packingMode[1].unit1}`;
  }
  return '';
}